/* eslint new-cap: 0 */
/* istanbul ignore file */
import _ from 'lodash';

export default function (window, document) {
    window.CARS = window.CARS || {};

    var CARS = window.CARS;

    CARS.PageState = (function() {

        trigger('ready.PageState');

        function trigger(event, details) {
            var pageStateEvent;
            if (typeof window.CustomEvent === 'function') {
                pageStateEvent = new CustomEvent(event, {
                    details: details
                });
            } else {
                var params = { bubbles: false, cancelable: false, detail: details };
                pageStateEvent = document.createEvent('CustomEvent');
                pageStateEvent.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            }
            document.body.dispatchEvent(pageStateEvent);
        }

        return {

            set: function setFn(key, value, emit) {
                emit = (typeof emit !== 'undefined') ? emit : true;

                var oldVal = _.get(CARS.digitalData, key);

                _.set(CARS.digitalData, key, value);

                if (emit) {
                    trigger('change.PageState', {
                        property: key,
                        how: 'set',
                        newVal: value,
                        oldVal: oldVal
                    });
                }
            },

            assign: function assignFn(object, emit) {
                emit = (typeof emit !== 'undefined') ? emit : true;

                _.assign(CARS.digitalData, object);

                if (emit) {
                    trigger('change.PageState', {
                        how: 'set',
                        newVal: object
                    });
                }

            },

            get: function getFn(key) {
                return _.get(CARS.digitalData, key);
            },

            delete: function deleteFn(key, emit) {
                emit = (typeof emit !== 'undefined') ? emit : true;

                var oldVal = _.get(CARS.digitalData, key);
                var prop = oldVal;

                if (_.isArray(oldVal)) {
                    prop.splice(_.indexOf(oldVal), 1);
                } else {
                    prop = [];
                }

                _.set(CARS.digitalData, key, prop);

                if (emit) {
                    trigger('change.PageState', {
                        property: key,
                        how: 'delete',
                        oldVal: oldVal
                    });
                }
            },

            last: function lastFn(key) {
                var prop = _.get(CARS.digitalData, key);

                if (_.isArray(prop)) {
                    return _.last(prop);
                } else {
                    return prop;
                }
            },

            push: function pushFn(key, value, emit) {
                emit = (typeof emit !== 'undefined') ? emit : true;

                var oldVal = _.get(CARS.digitalData, key);
                var arr = [];

                if (_.isArray(oldVal)) {
                    arr = oldVal;
                    arr.push(value);
                } else {
                    if (oldVal !== undefined){
                        arr.push(oldVal, value);
                    } else {
                        arr.push(value);
                    }
                }

                _.set(CARS.digitalData, key, arr);

                if (emit) {
                    trigger('change.PageState', {
                        property: key,
                        how: 'push',
                        newVal: value,
                        oldVal: oldVal
                    });
                }
            },

            pop: function popFn(key, emit) {
                emit = (typeof emit !== 'undefined') ? emit : true;

                var oldVal = _.get(CARS.digitalData, key);
                var arr = oldVal;
                var popped;

                if (_.isArray(arr)) {
                    popped = arr.pop();
                } else {
                    arr = [];
                }

                _.set(CARS.digitalData, key, arr);

                if (emit) {
                    trigger('change.PageState', {
                        property: key,
                        how: 'pop',
                        oldVal: oldVal
                    });
                }

                return popped;
            },

            clear: function setFn(key, emit) {
                emit = (typeof emit !== 'undefined') ? emit : true;

                var oldVal = _.get(CARS.digitalData, key);

                var defaultValue = null;
                if (_.isString(oldVal)) {
                    defaultValue = '';
                } else if (_.isArray(oldVal)) {
                    defaultValue = [];
                } else {
                    defaultValue = null;
                }

                _.set(CARS.digitalData, key, defaultValue);

                if (emit) {
                    trigger('change.PageState', {
                        property: key,
                        how: 'set',
                        newVal: defaultValue,
                        oldVal: oldVal
                    });
                }
            },

        };
    })();
}